

import React, { useRef, useMemo, useCallback } from 'react';
import { IframeSearchEngine } from './searchEngines';
import { useDocSearch } from './useDocSearch';
import SearchNavBar from './SearchNavBar';

const SearchableIframe = ({ src, title }) => {
  const iframeRef = useRef(null);

  // New engine per src — each tab gets its own worker
  const engine = useMemo(() => new IframeSearchEngine(), [src]);
  engine.setRef(iframeRef);

  const search = useDocSearch(engine);

  const handleLoad = useCallback(() => {
    // Walks iframe DOM directly from parent
    // Sends text to worker — main thread not blocked
    engine.onLoad();
  }, [engine]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <SearchNavBar {...search} />
      <iframe
        ref={iframeRef}
        src={src}
        title={title}
        width="100%"
        style={{ flex: 1, border: 'none' }}
        onLoad={handleLoad}
      />
    </div>
  );
};

export default React.memo(SearchableIframe);